/**
 * 注意本文件只维护页面必须的状态
 * 功能模块，如抽奖的状态请维护在模块内，通过modules导入
 * 纯展示模块，一般不需要维护状态
 */
import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import global from '@kk-activity-factory/global-data';

Vue.use(Vuex);

const state = {
    /**
     * 用户信息
     */
    user: {
        /**
         * uid为0时为游客
         */
        uid: 0,
        /**
         * status为1的时候为已登陆
         */
        status: 0,
    },
    /** 从activityEnginePage获取的页面数据 */
    pageData: null,
    /**
     * 页面安全top
     */
    safeTop: 0,
    /**
     * 页面安全bottom
     */
    safeBottom: 0,
    /**
     * 是否上报过PV
     */
    hasUploadPV: false,
    /**
     * app版本
     */
    appVersion: 0,
    /**
     * 当前页面组件信息
     */
    componentConfigList: [],
    /**
     * receive_page_status数据https://wiki.quickcan.com/pages/viewpage.action?pageId=188974739
     */
    pageStatus: {
        curr_page_is_visible: 0,
        action_origin: 1,
        route_source_name: '',
    },
    /**
     * 页面初始化时间
     */
    pageInitTime: new Date().getTime(),
    /**
     * 页面是否存在关闭挽留模块
     */
    hasCloseStayModule: false,
    /**
     * 页面顶部导航栏分享按钮信息
     */
    topBarShareButtonData: null,
    /**
     * 发现页位移量
     */
    findTabTranslate: null,
    /*
     * 是否用户首次访问页面
     */
    isFirstTime: false,
    /**
     * 是否用户当日首次访问页面
     */
    isCurrentDayFirstVisit: false,
    /**
     * 访问奖励弹窗已经完成
     */
    visitPrizeDialogReady: false,
    /**
     * 是否需要自动展示头图模块
     */
    shouFirstShowTitleImg: false,
    /**
     * 是否已经自动展示过头图模块
     */
    hasFirstShowTitleImg: false,
    /**
     * 头图模块流程处理完成
     */
    titleImgModuleProcessFinished: false,
    /**
     * 是否允许重复任务自动领奖
     * 在优先级处理完之后这个值被设置为true
     */
    allowRepetTaskAutoObtainPrize: false,
    /**
     * 大类容器已经可见
     * 主要解决时序问题
     */
    findLikeContainerHasVisible: false,
    /**
     * 用户头像
     */
    userAvatar: '',
    /**
     * 标识弹窗优先级处理是否已经执行
     */
    priorityProcessingStart: false,
};

const getters = {
    /**
     * 样式列表
     * @param {*} state
     * @returns
     */
    displayList(state) {
        if (state.pageData && state.pageData.displayModuleStyleConfigList) {
            return state.pageData.displayModuleStyleConfigList;
        } else {
            return [];
        }
    },
    /**
     * 模块分类标识
     */
    categoryMap(state, getters) {
        if (getters.displayList) {
            const map = new Map();
            const list = getters.displayList;
            list.forEach((item) => {
                map.set(item.tradingSourceIdentifier, item.classificationMark);
            });
            return map;
        }
        return new Map();
    },
    /**
     * 页面标题
     * @param {*} state
     * @returns
     */
    title(state) {
        if (state.pageData) {
            return state.pageData.name;
        } else {
            return '';
        }
    },
    /**
     * 页面背景色
     * @param {*} state
     * @returns
     */
    backgroundColor(state) {
        if (state.pageData && state.pageData.backgroundColor) {
            return state.pageData.backgroundColor;
        } else {
            return '#ffffff';
        }
    },
    /**
     * 活动标识
     */
    activityMark(state) {
        if (state.pageData) {
            return state.pageData.activityMark;
        } else {
            return '';
        }
    },
    activityId(state) {
        if (state.pageData) {
            return state.pageData.activityId;
        } else {
            return 0;
        }
    },
    cdnHost(state) {
        if (state.pageData) {
            return state.pageData.cdnHost;
        } else {
            return '';
        }
    },
    /**
     * 站外投放引导栏位置
     */
    outsideGuideBar(state) {
        if (state.pageData && state.pageData.offSiteGuideBar) {
            if (state.pageData.offSiteGuideBar == '1') {
                return 'bottom';
            } else {
                return 'top';
            }
        } else {
            return 'bottom';
        }
    },
    topNavigationBar(state) {
        return Boolean(
            state.pageData &&
                state.pageData.topNavigationBar &&
                (global.isKuaikan || global.innerPreview)
        );
    },
    deeplinkGuideStyle(state) {
        if (state.pageData && state.pageData.customBootstrapPopupDetail) {
            let style;
            try {
                style = state.pageData.customBootstrapPopupDetail;
            } catch (error) {
                style = null;
            }
            return style;
        } else {
            return null;
        }
    },
    published(state) {
        if (state.pageData) {
            return state.pageData.published;
        } else {
            return false;
        }
    },
    findTabTranslateValue(state) {
        if (state.findTabTranslate) {
            return Number(state.findTabTranslate.replace('vw', ''));
        } else {
            return null;
        }
    },
};

export function buildStore(moduleStore) {
    return new Vuex.Store({
        state: state,
        mutations: mutations,
        getters: getters,
        actions: actions,
        modules: moduleStore,
    });
}

// export default store;
